// extracted by mini-css-extract-plugin
export default {"AffichageAlerteCarteBancaire":"AffichageAlerteCarteBancaire_AffichageAlerteCarteBancaire__p0pg3","Message":"AffichageAlerteCarteBancaire_Message__nrLS8"};